import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const COVER_URL = "https://media-manager-c.questera.ai/greta-media/1020052fea4646cda0b6350a92290b5d8aad67ab848ee0e26ed330cb10bc0462b7cba33c940299c4772469600661d72c/images/aW1hZ2UvanBlZw==/efd9947c54ec63bdf05d179ef7cbb3e4.jpg";

const BookPromo = ({ variant = 'sidebar' }) => {
  const isSidebar = variant === 'sidebar';

  if (isSidebar) {
    return (
      <div className="bg-finance-blue text-white p-6 rounded-xl shadow-lg border border-slate-700 relative overflow-hidden group flex flex-col items-center text-center">
        <div className="mb-6 relative z-10">
          <img 
            src={COVER_URL} 
            alt="Der Dividenden-Investor Buchcover" 
            className="w-36 rounded-md shadow-2xl transform group-hover:scale-105 transition-transform duration-500 border border-slate-600"
          />
        </div>
        
        <h3 className="text-xl font-bold mb-3 relative z-10">Der Dividenden-Investor</h3>
        <p className="text-slate-300 text-sm mb-6 relative z-10 leading-relaxed">
          Das Standardwerk für Anleger im DACH-Raum. Lerne, wie du ein passives Einkommen mit Qualitätsaktien aufbaust.
        </p>
        
        <a 
          href="https://dividenden-investor.ch" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full bg-finance-green hover:bg-emerald-600 text-white font-bold py-3 rounded-lg transition-colors relative z-10"
        >
          Zum Buch <SafeIcon icon={FiArrowRight} />
        </a>
      </div>
    );
  }

  return (
    <div className="bg-white border-2 border-finance-blue/5 rounded-2xl p-8 flex flex-col md:flex-row items-center gap-8 my-12">
      <div className="flex-shrink-0 transform -rotate-3 hover:rotate-0 transition-transform duration-500 cursor-pointer">
        <img 
          src={COVER_URL} 
          alt="Der Dividenden-Investor Buchcover" 
          className="w-40 md:w-48 rounded-lg shadow-2xl border border-slate-200"
        />
      </div>
      
      <div className="flex-grow text-center md:text-left">
        <h3 className="text-2xl font-bold text-finance-blue mb-2">Sichere dir das fundierte Fachwissen</h3>
        <p className="text-slate-600 mb-6 max-w-xl">
          Entdecke im Buch "Der Dividenden-Investor" die bewährte Strategie für Deutschland, Österreich und die Schweiz – von der Aktienauswahl bis zur Steueroptimierung.
        </p>
        <a 
          href="https://dividenden-investor.ch" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-finance-blue text-white px-8 py-3 rounded-full font-bold hover:bg-finance-green transition-all"
        >
          Jetzt Buch entdecken <SafeIcon icon={FiArrowRight} />
        </a>
      </div>
    </div>
  );
};

export default BookPromo;